'use client'

import useSWR from 'swr'
import apiService from '../services/apiService'


export function useContract(reservationId: string) {
  const fetcher = (url: string) => apiService.getWithToken(url)

  const { data, error, isLoading } = useSWR(
    reservationId ? `/api/contracts/by-reservation/${reservationId}/` : null,
    fetcher
  )

  return {
    contract: data,
    isLoading,
    isError: error,
  }
}
